/**
 * Determines whether discount functionality should be visible/enabled
 * based on both company-level settings and UI configuration.
 *
 * @param lotsConfig - The lots configuration from ui_config, may contain show_discount setting
 * @param companyShowDiscount - Company-level setting that enables/disables discount functionality
 * @returns boolean indicating whether discount features should be shown
 */
export const shouldShowDiscount = (
  lotsConfig: { show_discount?: boolean } | null | undefined,
  companyShowDiscount = false
): boolean => {
  return Boolean(lotsConfig?.show_discount && companyShowDiscount);
};
